(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["airluxe-pinned"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('airluxe-pinned')) {
  customElements.define('airluxe-pinned', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');

      let hover = false;
      let touch = false;
      let visible = false;
      let last = 0;
      let x = 0;
      let direction = 1;
      let previous = null;

      this.addEventListener('pointerover', e => {
        if (
          e.pointerType === 'mouse' &&
          e.target.closest('.jdgm-cards-wrapper')
        ) {
          hover = true;
        }
      }, options);

      this.addEventListener('pointerout', e => {
        const wrapper = e.target.closest('.jdgm-cards-wrapper');
        if (wrapper && !wrapper.contains(e.relatedTarget)) {
          hover = false;
        }
      }, options);

      this.addEventListener('pointerdown', e => {
        if (e.pointerType !== 'mouse') touch = true;
      }, options);

      window.addEventListener('pointerup', () => {
        touch = false;
      }, options);

      window.addEventListener('pointercancel', () => {
        touch = false;
      }, options);

      this.observer = new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting;
      });
      this.observer.observe(this);

      const tick = time => {
        const dt = Math.min(time - last, 50) / 1000;
        last = time;

        const wrapper = this.querySelector('.jdgm-cards-wrapper');

        if (wrapper) {
          if (wrapper !== previous) {
            wrapper.tabIndex = 0;
            x = wrapper.scrollLeft;
            previous = wrapper;
          }

          const max = wrapper.scrollWidth - wrapper.clientWidth;

          if (
            visible &&
            !document.hidden &&
            !reduced.matches &&
            !hover &&
            !touch &&
            !wrapper.matches(':focus-visible') &&
            !wrapper.querySelector(':focus-visible') &&
            max > 1
          ) {
            if (Math.abs(wrapper.scrollLeft - x) > 2) {
              x = wrapper.scrollLeft;
            }

            x += direction * 18 * dt;

            if (x >= max) {
              x = max;
              direction = -1;
            }
            if (x <= 0) {
              x = 0;
              direction = 1;
            }

            wrapper.scrollLeft = x;
          } else {
            x = wrapper.scrollLeft;
          }
        }

        this.frame = requestAnimationFrame(tick);
      };

      this.frame = requestAnimationFrame(tick);
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["airluxe-ugc-videos"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('airluxe-ugc')) {
  customElements.define('airluxe-ugc', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const track = this.querySelector('.airluxe-ugc__track');
      const prev = this.querySelector('.airluxe-ugc__prev');
      const next = this.querySelector('.airluxe-ugc__next');

      const update = () => {
        const max = track.scrollWidth - track.clientWidth;
        prev.hidden = next.hidden = max < 2;
        prev.disabled = track.scrollLeft < 2;
        next.disabled = track.scrollLeft >= max - 2;
      };

      const move = direction => {
        const card = track.firstElementChild;
        if (!card) return;
        const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap);
        track.scrollBy({
          left: direction * step,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      };

      prev.addEventListener('click', () => move(-1), options);
      next.addEventListener('click', () => move(1), options);
      track.addEventListener('scroll', update, options);

      const videos = [...this.querySelectorAll('video')];
const visible = new Set();
const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');

videos.forEach(video => {
  video.muted = true;
  video.loop = true;
});

const sync = () => {
  videos.forEach(video => {
    if (visible.has(video) && !document.hidden && !reducedMotion.matches) {
      video.play().catch(() => { video.controls = true; });
    } else {
      video.pause();
    }
  });
};

const videoObserver = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    if (entry.isIntersecting && entry.intersectionRatio >= 0.25) {
      visible.add(entry.target);
    } else {
      visible.delete(entry.target);
    }
  });
  sync();
}, { threshold: [0, 0.25] });

videos.forEach(video => videoObserver.observe(video));
document.addEventListener('visibilitychange', sync, options);
reducedMotion.addEventListener('change', sync, options);

this.controller.signal.addEventListener('abort', () => {
  videoObserver.disconnect();
}, { once: true });

      this.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('.airluxe-ugc__card');
        if (card) track.scrollLeft += card.getBoundingClientRect().left - track.getBoundingClientRect().left;
      }, options);

      this.observer = new ResizeObserver(update);
      this.observer.observe(track);
      update();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.querySelectorAll('video').forEach(video => video.pause());
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
